import { dataMember, required } from 'santee-dcts';
import { KeyValuePair } from '../../documents/document-filter-item';
import { SubjectNaturalKey } from '../../subjects';
import { SubjectTitleRenderer } from '../../renderer/subject-title-renderer';

export class SubjectFilter {
    @dataMember()
    @required()
    public key: string;

    @dataMember()
    @required({ nullable: true })
    public initials: string;

    @dataMember()
    @required({ nullable: true })
    public subjectNumber: string;

    @dataMember()
    @required({ nullable: true })
    public screeningNumber: string;

    @dataMember()
    @required({ nullable: true })
    public subjectNaturalKey: string;

    public get zcSubjectId(): string {
        const result = SubjectNaturalKey.fromString(this.subjectNaturalKey);
        return result
            ? result.zcSubjectId
            : null;
    }

    public get value(): string {
        return SubjectTitleRenderer.renderSubjectNumberOrScreening(this);
    }

    public toString() {
        return this.value;
    }
}

export abstract class ExternalUserEQueriesFilter {
    @dataMember()
    @required({ nullable: true })
    public status: KeyValuePair;

    @dataMember()
    @required({ nullable: true })
    public subject: SubjectFilter;

    @dataMember()
    @required({ nullable: true })
    public visitName: KeyValuePair;

    @dataMember()
    @required({ nullable: true })
    public visitCode: KeyValuePair;

    @dataMember()
    @required({ nullable: true })
    public accessionNumber: KeyValuePair;

    @dataMember()
    @required({ nullable: true })
    public eQueryId: KeyValuePair;
}
